import { createFileRoute } from '@tanstack/react-router';

import { Reviews } from '@/pages/admin/reviews/Reviews';

export const Route = createFileRoute('/admin/_admin/reviews')({
  component: Reviews
});
